// extracted by mini-css-extract-plugin
module.exports = {"imageBox":"List_imageBox__2-sNp","plusIcon":"List_plusIcon__iIf48","mondaiButton":"List_mondaiButton__1HlcC","listBase":"List_listBase__1j3He"};